import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { styled } from '@mui/system';

import DashboardLeftSidebar from './DashboardLeftSidebar';
import DashboardNavbar from './DashboardNavbar';

const DashboardLayoutRoot = styled('div')(
    ({ theme, isSidebarOpened }) => ({
        backgroundColor: theme.palette.background.main,
        display: isSidebarOpened ? 'flex' : 'block',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
    })
);

const DashboardLayoutWrapper = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden'
    })
);

const DashboardLayoutContainer = styled('div')({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});

const DashboardLayoutContent = styled('div')({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
});

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;

    return { width, height };
}

function DashboardLayout() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [isSidebarOpened, setIsSidebarOpened] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if(!windowDimensions) {
            return;
        }

        //setIsSidebarOpened(windowDimensions.width < 650 ? false : true);
        //setIsMobile(windowDimensions.width < 650 ? true : false);

    },[windowDimensions]);

    return (
        <DashboardLayoutRoot isSidebarOpened={isSidebarOpened}>
            {
                isSidebarOpened
                    ? <DashboardLeftSidebar setIsSidebarOpened={setIsSidebarOpened} isMobile={isMobile} />
                    : <DashboardNavbar setIsSidebarOpened={setIsSidebarOpened} />
            }

            <DashboardLayoutWrapper>
                <DashboardLayoutContainer>
                    <DashboardLayoutContent>
                        <Outlet />
                    </DashboardLayoutContent>
                </DashboardLayoutContainer>
            </DashboardLayoutWrapper>
        </DashboardLayoutRoot>
    );
}

export default DashboardLayout;

/*
ARCHIVE

<DashboardLayoutWrapper>
    <DashboardLayoutContainer>
        <DashboardLayoutContent>
            <Outlet />
        </DashboardLayoutContent>
    </DashboardLayoutContainer>
</DashboardLayoutWrapper>
            
*/